import React, { JSX } from 'react';
import { FormConfig, InputSearchDropdownElement } from '../types/types';
import { ApiBaseData } from '@ibe/api';
import FormInputSearchDropdown from './FormInputSearchDropdown';

interface Props {
  config: InputSearchDropdownElement;
  keySuffix?: FormConfig['keySuffix'];
  externalData?: Record<string, unknown>;
}

const InputSearchDropdownWrapper = (props: Props): JSX.Element => {
  const {
    config: {
      tag,
      key,
      label,
      placeholder,
      boldLabel,
      showErrorIcon,
      disabled,
      disablePaste,
      type,
      onFocus,
      onBlur,
      options: selectOptions,
      externalDataOptions,
      validateOnBlurOnly,
      showSuccessState
    },
    keySuffix,
    externalData
  } = props;

  const options =
    selectOptions ||
    ((!!externalDataOptions && !!externalData && !!externalData[externalDataOptions]
      ? externalData[externalDataOptions]
      : []) as ApiBaseData[]);

  return (
    <FormInputSearchDropdown
      tag={tag}
      name={`${key}${keySuffix || ''}`}
      label={label}
      boldLabel={boldLabel}
      showErrors
      placeholder={placeholder}
      showErrorIcon={showErrorIcon}
      disabled={disabled}
      disablePaste={disablePaste}
      type={type}
      onFocus={onFocus}
      onBlur={onBlur}
      options={options}
      validateOnBlurOnly={validateOnBlurOnly}
      showSuccessState={showSuccessState}
    />
  );
};

export default InputSearchDropdownWrapper;
